package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@JsExport
@Serializable
class LinkedDevice(
    @SerialName("id") val id: String,
    @SerialName("userId") val userId: String,
    @SerialName("createdAt") val createdAt: Long,
    @SerialName("updatedAt") val updatedAt: Long? = null,
    @SerialName("friendlyName") val friendlyName: String,
    @SerialName("deviceId") val deviceId: String,
    @SerialName("deviceInstanceId") val deviceInstanceId: String,
    @SerialName("serialNumber") val serialNumber: String,
    @SerialName("modelName") val modelName: String,
    @SerialName("soc") val soc: String? = null,
    @SerialName("chipset") val chipset: String? = null,
    @SerialName("iotConnectivity") val iotConnectivity: IoTConnectivity? = null,
    @SerialName("vizioPayData") val vizioPayData: VizioPayData? = null,
    @SerialName("voiceOptions") val voiceOptions: VoiceOptions? = null,
    @SerialName("alexaEnabled") val alexaEnabled: Boolean,
    @SerialName("alexaSynced") val alexaSynced: Boolean,
    @SerialName("googleAssistantEnabled") val googleAssistantEnabled: Boolean,
    @SerialName("googleAssistantSynced") val googleAssistantSynced: Boolean
)
